$(function(){

    // append warning content to sensitive class
    $('.LpWoundsStoryImageIsSensitive').each(function(){
        const warningContent = `
            <div class="LpWoundsStoryImageOverlayWarning">
                <svg>
                    <use xlink:href="#icon-eye-slash-solid"></use>
                </svg>
                <p>citlivý obsah</p>
                <button>zobrazit</button>
            </div>
        `;
        $(this).find('.LpWoundsStoryImageOverlay').prepend(warningContent);
    });

    // remove sensitive class after click on button and remove warning content
    $('.LpWoundsStoryImageIsSensitive').on('click', 'button', function(e){
        const $imageWrapper = $(e.target).parents('.LpWoundsStoryImageIsSensitive');
        $imageWrapper.removeClass('LpWoundsStoryImageIsSensitive');
        $imageWrapper.find('.LpWoundsStoryImageOverlayWarning').remove();
    });

});